import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet";
import imgHead from "../assets/imgs/blog/post01.jpg";
import { Link } from "react-router-dom";
import itemsPostData from "../data/itemsPostData";

export const BlogPage = () => {
  useEffect(() => {
    const scrollToTop = () => {
      window.scrollTo(0, 0);
    };
    scrollToTop();
  });

  const { t } = useTranslation();

  const latestPost = itemsPostData.at(-1);
  const otherPosts = itemsPostData.slice(0, -1);

  return (
    <>
      <Helmet>
        <title>{t("Blog - JC Innovation")}</title>
      </Helmet>
      <section className="wrapper_page_blog wrapper__page_services">
        <div className="contain__head_page">
          <div className="container-lg">
              <div className="row g-5 align-items-center">
                <div className="col-md-6">
                  <p className="category_destacado">
                    <span className="trans">{latestPost.category}</span>
                  </p>
                  <Link  to={`/blog/${latestPost.id}/${latestPost.slug}`} key={latestPost.id}>
                    <h1 className="ttls ttl_section c_morado mb-2 fw_700">
                      {latestPost.title}
                    </h1>
                  </Link>
                  <p className="paragraph lg fw_600 c_marin">
                    {latestPost.subtitle}
                  </p>
                  <div className="content_extract">
                    <p className="paragraph lg">
                     {latestPost.extract}
                    </p>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="box_picture_post">
                    <img
                      className="trans"
                      src={latestPost.picture}
                      alt={t("Organización de Congresos")}
                    />
                  </div>
                </div>
              </div>
          </div>
        </div>
        <div className="contain__gral_posts">
          <div className="container-lg">
            <h4 className="ttls ttl_section c_morado mb-2 fw_600 text-center mb-5">
              ¡Explora más publicaciones!
            </h4>
            <div className="gral_items_posts">
              {otherPosts.map((itemPost) => (
                <Link
                  to={`/blog/${itemPost.id}/${itemPost.slug}`}
                  key={itemPost.id}
                  className="post_item"
                >
                  <div className="box_picture_post">
                    <img
                      className="picture_post trans"
                      src={itemPost.picture}
                      alt={itemPost.title}
                    />
                  </div>
                  <div className="px-3">
                    <p className="category">
                      <span className="trans">{itemPost.category}</span>
                    </p>
                    <h4 className="post_title">{itemPost.title}</h4>
                    <p>{itemPost.extract}</p>
                    <p className="date text-end">{itemPost.date}</p>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
